"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATION_ERRORS = void 0;
var VALIDATION_ERRORS;
(function (VALIDATION_ERRORS) {
    VALIDATION_ERRORS["CIRCLE"] = "circle_exists";
    VALIDATION_ERRORS["UNUSED_NODES"] = "unused_nodes_exist";
    VALIDATION_ERRORS["WRONG_CONTEXT_REFERENCE"] = "wrong_context_reference";
})(VALIDATION_ERRORS || (exports.VALIDATION_ERRORS = VALIDATION_ERRORS = {}));
